import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';

import { UploadTrackForm } from './UploadTrackForm';

type Props = {
  strategyId: string;
  onClose: () => void;
};

export const UploadTrackDialog = ({ strategyId, onClose }: Props) => (
  <Dialog open onClose={onClose} maxWidth="md" fullWidth aria-labelledby="upload-track-dialog-title">
    <DialogTitle id="upload-track-dialog-title" align="center">
      Загрузка трека
    </DialogTitle>
    <IconButton
      aria-label="close"
      onClick={onClose}
      sx={(theme) => ({
        position: 'absolute',
        right: 8,
        top: 8,
        color: theme.palette.grey[500],
      })}
    >
      <CloseIcon />
    </IconButton>
    <DialogContent dividers>
      <UploadTrackForm strategyId={strategyId} onClose={onClose} />
    </DialogContent>
  </Dialog>
);
